import { Component, Input } from '@angular/core';

@Component({
  selector: 'atom-logo-image',
  templateUrl: './logo-image.component.html',
  styleUrls: ['./logo-image.component.scss']
})
export class LogoImageComponent {
  @Input() imagePath: string = '../../../../assets/images/logo-volga.png'; // valor por defecto
  @Input() altText: string = 'Logo'; // valor por defecto
}